export default __webpack_public_path__ + "static/media/Componente3551.25cc5eee.svg";